
import { defineComponent } from "vue";
import EntityDetails from "../../entity/EntityDetails.vue";

export default defineComponent({
    name: "AcquisitionDetails",
    components: { EntityDetails },
});
